import {getHasBuildsArg} from '../../../rest/builds'
import type {Branch} from '../../../services/rest'
import type {BuildTypeId} from '../../../types'
import {getPermalinkLocator} from '../../../utils/permalinks'

export function getPermalinkArg({
  buildTypeId,
  branch,
  type,
}: {
  buildTypeId: BuildTypeId
  branch?: Branch | null | undefined
  type: string
}) {
  const locator = getPermalinkLocator(type, buildTypeId, branch)

  return locator != null ? getHasBuildsArg(locator) : null
}
